import { render, staticRenderFns } from "./DocutaxRequest.vue?vue&type=template&id=0737ff66&"
import script from "./DocutaxRequest.vue?vue&type=script&lang=js&"
export * from "./DocutaxRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports